import Notification from 'components/Notification';
import * as React from 'react';
export default {
  Notification,
  React
};